// @ts-nocheck
async function initPushNotifications () {
    const pushBox = document.querySelector('#subscription-status');
    if (!pushBox) {
        return;
    }

    const applicationServerKey = pushBox.dataset.applicationkey;
    const pushButton = document.querySelector('#push-subscription-button');
    const toggleButton = document.querySelector('#toggle-subscription-status-button');
    const subscriptionHeadline = document.querySelector('#subscription-status-title');
    let isPushEnabled = false;

    // for animation purposes
    pushBox.style.transform = 'translateZ(0)';

    const texts = {
        enabled: pushBox.dataset.enabled,
        disabled: pushBox.dataset.disabled,
        incompatible: pushBox.dataset.incompatible,
        computing: pushBox.dataset.computing
    };

    if (isIos()) {
        // iOS does not support push notifications in the browser
        pushBox.style.display = 'none';
        pushBox.style.opacity = 0;
    }

    function isIos () {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    function updatePushBox () {
        if (localStorage.getItem('pushBoxClosed') === null) {
            setTimeout(() => {
                showPushBox();
            }, 300);
        }
        if (localStorage.getItem('pushBoxClosed') === 'true') {
            setButtonStatesForClosedBox();
            setTimeout(() => {
                closePushBox();
            }, 300);
        }
        if (localStorage.getItem('pushBoxClosed') === 'false') {
            setTimeout(() => {
                showPushBox();
            }, 300);
        }
    }

    // update push box
    updatePushBox();

    // if user clicks on the button, we need to subscribe or unsubscribe
    pushButton.addEventListener('click', async function () {
        if (isPushEnabled) {
            showPushBox();
            unsubscribe();
        } else {
            await subscribe();
            await closePushBox();
            await changePushButtonState('hidden');
            await changeToggleButtonState('subscribed');
        }
    });

    // if user clicks on the close button, we need to close the box
    toggleButton.addEventListener('click', function () {
        if (PushBoxIsClosed()) {
            showPushBox();
        } else {
            closePushBox();
        }
    });

    subscriptionHeadline.addEventListener('click', function () {
        if (PushBoxIsClosed()) {
            showPushBox();
        } else {
            closePushBox();
        }
    });

    function changeToggleButtonState (state) {
        switch (state) {
            case 'close':
                toggleButton.querySelector('.inner-text').textContent = toggleButton.dataset.opened;
                toggleButton.querySelector('.sub-icon').classList.remove('d-none');
                toggleButton.classList.remove('d-none');
                break;
            case 'open':
                toggleButton.querySelector('.inner-text').textContent = toggleButton.dataset.closed;
                toggleButton.querySelector('.sub-icon').classList.add('d-none');
                toggleButton.classList.remove('d-none');
                break;
            case 'subscribed':
                toggleButton.querySelector('.inner-text').textContent = toggleButton.dataset.subscribed;
                toggleButton.querySelector('.sub-icon').classList.add('d-none');
                toggleButton.classList.remove('d-none');
                break;
            case 'hidden':
                toggleButton.classList.add('d-none');
                break;
            default:
                break;
        }
    }

    function getPushBoxState () {
        return pushBox.dataset.subscriptionstatus;
    }

    function changePushBoxState (state) {
        switch (state) {
            case 'subscribed':
                pushBox.dataset.subscriptionstatus = 'subscribed';
                break;
            case 'unsubscribed':
                pushBox.dataset.subscriptionstatus = 'unsubscribed';
                break;
            default:
                break;
        }
    }

    if (!('serviceWorker' in navigator) ||
        !('PushManager' in window) ||
        Notification.permission === 'denied' ||
        !('showNotification' in ServiceWorkerRegistration.prototype)) {
        changePushButtonState('incompatible');
        return;
    }

    navigator.serviceWorker.register('/ws.js').then(() => {
        push_updateSubscription();
    }, e => {
        changePushButtonState('incompatible');
    });

    function setButtonStatesForOpenBox () {
        changeToggleButtonState('close');
        changePushButtonState('visible');
    }

    function setButtonStatesForClosedBox () {
        if (getPushBoxState() === 'subscribed') {
            changeToggleButtonState('subscribed');
            changePushButtonState('hidden');
        } else {
            changeToggleButtonState('hidden');
            changePushButtonState('disabled');
        }
    }

    function closePushBox () {
        if (pushBox.classList.contains('closed')) return;
        // save into local storage that the user closed the box
        localStorage.setItem('pushBoxClosed', 'true');

        setButtonStatesForClosedBox();

        animatePushBox('close');

    }

    function showPushBox () {
        if (!pushBox.classList.contains('closed')) return;

        setButtonStatesForOpenBox();

        // check if the user closed the box
        if (getPushBoxState() !== 'subscribed') {
            localStorage.setItem('pushBoxClosed', 'false');
            // save into local storage that the user closed the box
        } else {
            localStorage.setItem('pushBoxClosed', 'true');
        }

        animatePushBox('open');

    }

    function animatePushBox (state) {

        // get height of pushbox
        const startHeight = pushBox.offsetHeight;

        // show or hide the box
        if (state === 'open') {
            pushBox.classList.remove('closed');
        } else if (state === 'close') {
            pushBox.classList.add('closed');
        }

        // get height of closed pushbox
        const endHeight = pushBox.offsetHeight;

        // set height to initial height of pushbox
        pushBox.style.height = startHeight + 'px';

        // animate height to end height of pushbox
        requestAnimationFrame(() => {
            pushBox.style.height = endHeight + 'px';
        });

        pushBox.addEventListener('transitionend', () => {
            pushBox.style.height = 'auto';
        }, { once: true });

        setTimeout(() => {
            pushBox.style.height = 'auto';
        }, 500);

    }

    function PushBoxIsClosed () {
        return pushBox.classList.contains('closed');
    }

    function changePushButtonState (state) {

        pushButton.style.display = 'block';

        switch (state) {
            case 'enabled':
                pushButton.textContent = texts.enabled;
                pushButton.classList.add('btn-transparent');
                pushButton.disabled = false;
                pushButton.classList.remove('d-none');
                isPushEnabled = true;
                closePushBox();
                break;
            case 'disabled':
                pushButton.textContent = texts.disabled;
                pushButton.classList.remove('btn-transparent');
                pushButton.disabled = false;
                pushButton.classList.remove('d-none');
                isPushEnabled = false;
                break;
            case 'computing':
                pushButton.disabled = true;
                pushButton.textContent = texts.computing;
                pushButton.classList.add('btn-transparent');
                pushButton.classList.remove('d-none');
                break;
            case 'incompatible':
                pushBox.style.display = 'none';
                break;
            case 'hidden':
                pushButton.classList.add('d-none');
                break;
            case 'visible':
                pushButton.classList.remove('d-none');
                break;
            default:
                break;
        }

        setTimeout(() => {
            // show the button
            pushButton.style.opacity = 1;
        }, 500);
    }

    function urlBase64ToUint8Array (base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    function checkNotificationPermission () {
        return new Promise((resolve, reject) => {
            if (Notification.permission === 'denied') {
                return reject(new Error('Push messages are blocked.'));
            }

            if (Notification.permission === 'granted') {
                return resolve();
            }

            if (Notification.permission === 'default') {
                return Notification.requestPermission().then(result => {
                    if (result !== 'granted') {
                        reject(new Error('Bad permission result'));
                    } else {
                        resolve();
                    }
                });
            }

            return reject(new Error('Unknown permission'));
        });
    }

    async function subscribe () {
        changePushButtonState('computing');

        try {
            await checkNotificationPermission();
            const serviceWorkerRegistration = await navigator.serviceWorker.ready;
            const subscription = await serviceWorkerRegistration.pushManager.subscribe({
                userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(applicationServerKey)
            });
            const subscription_2 = await sendSubscriptionToServer(subscription, 'POST');
            changePushBoxState('subscribed');
            return subscription_2 && changePushButtonState('enabled');
        } catch (e) {
            if (Notification.permission === 'denied') {
                // The user denied the notification permission which
                // means we failed to subscribe and the user will need
                // to manually change the notification permission to
                // subscribe to push messages
                changePushButtonState('incompatible');
            } else {
                // A problem occurred with the subscription; common reasons
                // include network errors or the user skipped the permission
                changePushButtonState('disabled');
            }
        }
    }

    function push_updateSubscription () {
        navigator.serviceWorker.ready
            .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
            .then(subscription => {
                if (!subscription) {
                    // We aren't subscribed to push, so set UI to allow the user to enable push
                    changePushButtonState('disabled');
                    changePushBoxState('unsubscribed');
                    return;
                }
                // Keep your server in sync with the latest endpoint
                return sendSubscriptionToServer(subscription, 'PUT');
            })
            .then(function (subscription) {
                if (subscription) {
                    changePushButtonState('enabled');
                    changeToggleButtonState('open');
                    changePushBoxState('subscribed');
                }
                updatePushBox();
            }) // Set your UI to show they have subscribed for push messages
            .catch(e => {
                console.error('Error when updating the subscription', e);
            });
    }

    function unsubscribe () {
        changePushButtonState('computing');

        // To unsubscribe from push messaging, you need to get the subscription object
        navigator.serviceWorker.ready
            .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
            .then(subscription => {
                // Check that we have a subscription to unsubscribe
                if (!subscription) {
                    // No subscription object, so set the state
                    // to allow the user to subscribe to push
                    changePushButtonState('disabled');
                    changePushBoxState('unsubscribed');
                    return;
                }

                // We have a subscription, unsubscribe
                // Remove push subscription from server
                return sendSubscriptionToServer(subscription, 'DELETE');
            })
            .then(subscription => subscription.unsubscribe())
            .then(() => {
                changePushButtonState('disabled');
                changePushBoxState('unsubscribed');
            })
            .catch(e => {
                // We failed to unsubscribe, this can lead to
                // an unusual state, so  it may be best to remove
                // the users data from your data store and
                // inform the user that you have done so
                changePushButtonState('disabled');
            });
    }

    async function sendSubscriptionToServer (subscription, method) {
        const key = subscription.getKey('p256dh');
        const token = subscription.getKey('auth');
        const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];

        await fetch('/subscribe/handle', {
            method, body: JSON.stringify({
                endpoint: subscription.endpoint,
                publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
                contentEncoding
            })
        });
        return subscription;
    }

}

export { initPushNotifications };
